import styled from 'styled-components'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'

export const FactImageWrapper = styled(PS.ImageWrapper)`
  max-width: 275px;
  margin: 0 auto 16px;
  border-radius: 10px;
  overflow: hidden;
`
